import { Grid } from "@material-ui/core";
import React from "react";
import { DataCard, DataCardDefaultItem } from "@ofqual/portal-components/components/DataCard/DataCard";
import { ReferenceModel } from "../../domain/ReferenceModel";

export const References: React.FC<{
  references: ReferenceModel[]
}> = ({ references }) => {

  const displayReferences = (reference: ReferenceModel) => {
    const items: DataCardDefaultItem[] = [
      {
        itemType: "DEFAULT",
        key: "Full name",
        value: reference.fullName
      },
      {
        itemType: "DEFAULT",
        key: "Email address	",
        value: reference.email,
      },
      {
        itemType: "DEFAULT",
        key: "Telephone number",
        value: reference.telephoneNumber,
      },
      {
        itemType: "DEFAULT",
        key: "Company or organisation name",
        value: reference.organisationName
      }
    ]
    return items
  }

  return (
    <>
      <div style={{ overflowWrap: 'break-word' }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {
              references.map((reference, index) => {
                return (
                  <React.Fragment key={index}>
                    {index > 0 ? <br /> : <></>}
                    <DataCard
                      showHeading={false}
                      heading={null}
                      items={displayReferences(reference)}
                      hasAction={false}
                      actionDescription={null}
                      actionButtonText={null}
                      actionFunction={null}
                      headingComponent={"h1"}
                    />
                  </React.Fragment>
                );
              })
            }
          </Grid>
        </Grid>
      </div>
    </>
  );
};
